import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { Options } from 'ng5-slider';
import { Subject } from 'rxjs';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { Loading } from 'src/app/Class/Loading';
import { ConsultasService } from 'src/app/servicios/consultas.service';
import { FuncionesJSService } from 'src/app/servicios/funciones-js.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-consultas-encuestas',
  templateUrl: './consultas-encuestas.component.html',
  styleUrls: ['./consultas-encuestas.component.css']
})
export class ConsultasEncuestasComponent implements OnInit {

  public filtro: FormGroup;
  public descriptores: any = [];
  public tiposSolicitantes: any = [];
  public tiposCasos: any = [];
  public estadosPqrs: any = [];
  public tiposVinculacion: any = [];
  public tiposIdentificacion: any = [];
  public datosFiltrados: any = [];
  public serve: string;
  public options: Options = { floor: 0, ceil: 0, step: 1 };
  public years = [0,0];
  public sw: number =0;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: any = Object.assign({}, DTConfig.dtConf);
  public dtTrigger: Subject<any> = new Subject();
  botones: FuncionesJSService;

  constructor(private consultaService: ConsultasService, private form: FormBuilder, public loading: Loading, private funciones: FuncionesJSService) {
    this.botones = funciones;
    this.serve = this.consultaService.getServe();
    this.filtro = this.form.group({
      fechaInicioCreación: [''],
      fechaFinalCreación: [''],
    });
      
  }

  ngOnInit() {
  }


  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngAfterViewChecked(): void {
    this.funciones.reemplazarBotonesDatatable();
  }

  filtrarPqrs() {
    if (!this.filtro.valid) {
      Swal.fire({
        type: 'error',
        title: 'Error',
        text: 'Verifique los datos e intente nuevamente',
        showConfirmButton: false,
        timer: 1500
      });
    }
    else {

      this.consultaService.getDataConsultasEncuestas(this.filtro.value)
      .subscribe(data => {
        this.datosFiltrados = data['success'] ? data['listado'] : [];
        if(this.sw==0){   this.Botones(); this.dtTrigger.next(); this.sw=1;}else{ this.Botones(); this.rerender();}
      });
    }
  }

  Botones(){ 
    this.dtOptions.order = [[ 1, "asc" ]];
    this.dtOptions.dom = "Bfrtip";
    this.dtOptions.autoWidth = false;
    this.dtOptions.buttons = [
      {
        extend: 'copy',
        text: 'Copiar',
        exportOptions: { columns: [0, 1, 2, 3, 4, 5, 6, 7] }
      },
      {
        extend: 'print',
        text: 'Imprimir',
        exportOptions: { columns: [0, 1, 2, 3, 4, 5, 6, 7] }
      },
      {
        extend: 'excel',
        text: 'Excel',
        exportOptions: { columns: [0, 1, 2, 3, 4, 5, 6, 7] }
      }
      
    ];
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

}
